export default __webpack_public_path__ + "static/galleria-c4a06deec231d38f4988c7f7c76a420d.jpeg";